import {IComponentOptions} from "angular";
import {hueColourSelectControllerBindings, HueColourSelectParentComponent} from "../hue-colour-select.parent.component";


type ColorHue = { color: string, hue: string, hex: string, colorName: string };

export class SingleHueColourSelectComponent extends HueColourSelectParentComponent {

    public static instance: IComponentOptions = {
        template: require('./single-hue-colour-select.component.html'),
        controller: hueColourSelectControllerBindings(SingleHueColourSelectComponent),
        bindings: {
            title: '@',
            selectedColour: '=',
            hues: '<',
            selectedColourValueChange: '<',
        }
    };

    private allColourHues: ColorHue[];
    private hues: string[];


    $onInit(): void {
        let allColourHues: ColorHue[] = [];
        for (let palletColour of this.palleteColors) {
            for (let hue of this.hues) {
                allColourHues.push({
                    colorName: this.getColourName(palletColour, hue),
                    color: palletColour,
                    hue: hue,
                    hex: this.getColourHexByNameAndHue(palletColour, hue)
                });
            }
        }
        this.allColourHues = allColourHues;
    }

}